import { render, staticRenderFns } from "./AssignOwnerModal.vue?vue&type=template&id=4133e25a&scoped=true"
import script from "./AssignOwnerModal.vue?vue&type=script&lang=js"
export * from "./AssignOwnerModal.vue?vue&type=script&lang=js"
import style0 from "./AssignOwnerModal.vue?vue&type=style&index=0&id=4133e25a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133e25a",
  null
  
)

export default component.exports